'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var IS_PROD = process.env.GATSBY_ENV === 'production';

var hasPages = function hasPages(pages) {
  return pages && pages.length > 0;
};

var setLink = function setLink(link, slug) {
  return link !== null ? link : slug;
};

var setRootSlug = function setRootSlug(link, slug) {
  return link.includes('http') ? link : IS_PROD ? "https://".concat(link) : "/".concat(slug);
};

var cleanPages = function cleanPages(cats, parentSlug) {
  return cats.map(function (_ref) {
    var name = _ref.name,
        link = _ref.link,
        slug = _ref.slug,
        lg_pages = _ref.lg_pages;
    var newSubPages = hasPages(lg_pages) ? cleanPages(lg_pages, "".concat(parentSlug, "/").concat(slug)) : [];
    return {
      name: name,
      link: setLink(link, "".concat(parentSlug, "/").concat(slug)),
      lg_pages: newSubPages
    };
  });
};

var cleanMenuData = function cleanMenuData(data) {
  var newData = data.map(function (_ref2) {
    var name = _ref2.name,
        link = _ref2.link,
        slug = _ref2.slug,
        lg_pages = _ref2.lg_pages;
    var rootSlug = setRootSlug(link, slug);
    var newPages = hasPages(lg_pages) ? cleanPages(lg_pages, rootSlug) : [];
    return {
      name: name,
      link: rootSlug,
      lg_pages: newPages
    };
  });
  return newData;
};

exports.cleanMenuData = cleanMenuData;